import { useContext, useState } from "react";
import { lddStateObject, setInternetDown, setShowRenewSession } from "../redux/reducer";
import { NavObjectType, lddGlobalSessionInfo } from "./navigationTypes";
import { useDispatch } from "react-redux";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { Loading } from "./Loading";
import { NavigationContext } from "../Context/NavigationContext";
import { useAppSelector } from "../redux/hooks";

function renewMSSession(URLsid: string, SessionInfo: lddGlobalSessionInfo): void {
    var loc = "" + window.origin;
    let url = `${loc}/rplus/azure_login.asp?redirect=RenewSessionMS.html&app=${SessionInfo.appCode}&SessionID=${URLsid}`;
    let params = `width=600,height=600,left=100,top=100`;
    let w = window.open(url, "msrenew", params);
}

interface IProps {
    URLsid: string,
    info: lddGlobalSessionInfo,
    page: NavObjectType,
}

const RenewSessionPopup = (props: IProps) => {
    const nav = useContext(NavigationContext);
    const isRenewSession = useAppSelector((state: lddStateObject) => state.ShowRenewSession);
    const isInternetDown = useAppSelector((state: lddStateObject) => state.InternetDown);
    window.addEventListener('message', (event) => {
        if (event.source !== window) {
            let source = event.source as any;
            if (source.location.href.toLowerCase().indexOf("renewsessionms.html") !== -1) {
                if (event.data && event.data.Msg && event.data.Msg === "1000") {
                    ReconnectConnection(props.info.appProvinceShort)
                }
            }
        }
    })
    const [validated, setValidated] = useState(false);
    const [renewStepLoading, setRenewStepLoading] = useState(false);
    const [renewErrorMsg, setRenewErrorMsg] = useState('');
    const dispatch = useDispatch();

    async function ReconnectConnection(prov) {
        let res = await fetch(`/rplus/${prov}/RenewSessionID.asp?SessionID=${props.URLsid}`);
        let response = await res.text();
        if (response.indexOf("<Error>") === -1) {
            dispatch(setInternetDown(false));
        } else if (response.indexOf("<Error>") !== -1 && response.indexOf("reason: Timed Out") !== -1) {
            dispatch(setInternetDown(false));
            dispatch(setShowRenewSession(true));
        }
    }

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        var v = true;
        if (form.checkValidity() === false) {
            console.log('valid false')
            v = false;
        }
        event.preventDefault();
        event.stopPropagation();
        setValidated(true);
        if (v) {
            setRenewStepLoading(true)
            var url = `/rplus/${props.info.appProvinceShort}/ReactivateCurrentSession.asp?SessionID=${props.URLsid}&NoHeader=1&action=y`;
            var p = (document.getElementById("formRenewPassword") as HTMLInputElement).value;
            var content = `<Root Password="${p}"/>`
            try {
                fetch(url, { method: "POST", body: content }).then(response => {
                    response.text().then(res => {
                        var err = "";
                        setRenewStepLoading(false);
                        if (res.indexOf("<Error>") !== -1) {
                            err = res.substring(res.indexOf("<Error>") + 7, res.indexOf("</Error"))
                            setRenewErrorMsg(err);
                        }
                        else if (res.indexOf("<ErrorMsg>") !== -1) {
                            err = res.substring(res.indexOf("<ErrorMsg>") + 10, res.indexOf("</ErrorMsg"))
                            setRenewErrorMsg(err);
                        }
                        else {
                            // reactivate successfully
                            setRenewErrorMsg("");
                            dispatch(setShowRenewSession(false));
                            // check if need to reload webapp iframe
                            const iframeContent: any = document.querySelector("#lddIFrame > iframe");
                            if (iframeContent && iframeContent.contentDocument.querySelector(".login-container")) {
                                nav({ ...props.page, init: true })
                            }
                            if (props.page.component == 'formlist') {
                                // nav({ ...props.page, init: true})
                                window.location.reload();
                            }
                        }
                    })
                })
            } catch (e) {
                setRenewErrorMsg(e);
                setRenewStepLoading(false);
            }
        }
    };

    return (
        <>
            {isInternetDown &&
                <Modal centered show={true}>
                    <Modal.Header>
                        <Modal.Title>Connection  Interrupted</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Alert variant="warning">An error occured when renewing your session at {(new Date()).toLocaleString()}.</Alert>
                        <p>The most likely reason is that your Internet connection interrupted.</p>
                        <p>To avoid losing unsaved data, please follow these steps:</p>
                        <ol>
                            <li>Keep this message open</li>
                            <li>Fix your Internet connection problem if any</li>
                            <li>Make sure your Internet works (e.g. open another tab and go to another website)</li>
                            <li>If the Internet connection works properly, click 'Renew' below to reactivate your session, otherwise repeat the steps above.</li>
                        </ol>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={() => ReconnectConnection(props.info.appProvinceShort)}>Renew Session</Button>
                    </Modal.Footer>
                </Modal>
            }
            {(!isInternetDown && isRenewSession) &&
                <Modal centered show={true} size="sm">
                    <Modal.Header>
                        <Modal.Title>Session Timeout</Modal.Title>
                    </Modal.Header>
                    {renewStepLoading &&
                        <>
                            <Modal.Body>
                                <Loading showMsg={true} extraMsg="Renewing session" inline={true} />
                            </Modal.Body>
                            <Modal.Footer>
                            </Modal.Footer>
                        </>
                    }
                    {!renewStepLoading && props.info.MSLoginEmail === "" &&
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <Modal.Body no-enforce-focus="true" style={{ height: "auto" }}>
                                {renewErrorMsg > "" && <Alert variant="danger">
                                    {renewErrorMsg}
                                </Alert>
                                }
                                <Form.Group controlId="formRenewAccount">
                                    <Form.Label>Account</Form.Label>
                                    <Form.Control disabled required type="text" placeholder="Enter your accout" defaultValue={props.info.firm.account} />
                                    <Form.Control.Feedback type="invalid">Please fill in your account</Form.Control.Feedback>
                                </Form.Group>
                                <br />
                                <Form.Group controlId="formRenewSubAccount">
                                    <Form.Label>User</Form.Label>
                                    <Form.Control disabled type="text" placeholder="Enter your user name if not admin" defaultValue={props.info.user.account} />
                                </Form.Group>
                                <br />
                                <Form.Group controlId="formRenewPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control required type="password" placeholder="Enter your password" autoFocus />
                                    <Form.Control.Feedback type="invalid">Please fill in your password</Form.Control.Feedback>
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="submit">Login</Button>
                            </Modal.Footer>
                        </Form>
                    }
                    {!renewStepLoading && props.info.MSLoginEmail > "" &&
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <Modal.Body no-enforce-focus="true">
                                {renewErrorMsg > "" && <Alert variant="danger">
                                    {renewErrorMsg}
                                </Alert>
                                }
                                <p>Your RealtiWeb Session has timed out. In order to reconnect, please do the following:
                                    <br />1. Click "Login with Microsoft".
                                    <br />2. A new window will open. Enter your Microsoft login information, if required.
                                    <br />3. Once the login was completed successfully, close the new window and proceed to RealtiWeb.
                                </p>
                                <div> </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button onClick={() => renewMSSession(props.URLsid, props.info)}>Login with Microsoft</Button>
                            </Modal.Footer>
                        </Form>
                    }
                </Modal>
            }
        </>
    )
}

export default RenewSessionPopup;